import React, {  } from 'react'
import { Checkbox, FormControlLabel, } from '@material-ui/core';
import CustomLabel from './CustomLabel'

const Observers = ({
    form: { setFieldValue, setFieldTouched },
    field: { value: values, name},
    variant,
    options,
    disabled,
    label,
    ...rest
}) => {

    const handleChange= (person, checked) => {
        setFieldTouched(name, true)
        setFieldValue(name, checked ? [...values, person.id] : values.filter(id=>id!==person.id))
    }
    return (
        <>
            <CustomLabel text={label}></CustomLabel>
            {   options.map(person=>{
                    return <FormControlLabel key={person.id}
                        control={<Checkbox 
                                    disabled={disabled}
                                    name={name} 
                                    defaultChecked={values.includes(person.id)}
                                    onChange={event=>handleChange(person, event.target.checked)}
                                />}
                        label={person.fullname}
                    />
                })
            }
        </>
    )
}

export default Observers
